import type { CollectionTypesListRow } from "@/admin/entities/collectionTypes";
import type { CollectionTypesListQueryType } from "@/types/graphql/admin.generated";

export function getTableData(data: unknown): {
  nodes: CollectionTypesListRow[];
  count: number;
} {
  const list = (data as CollectionTypesListQueryType)?.collectionTypes;

  if (!list?.nodes) {
    return { nodes: [], count: 0 };
  }

  return list;
}

export function mapColumns(row: CollectionTypesListRow) {
  return [
    row.id,
    row,
    row.showInSearch,
    row.collectionDisplayMode,
    row.createdAt,
  ];
}
